import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  countCharacters(pointerEvent) {
    const count = pointerEvent.target.value.length;

    document.getElementById('onHoldCharacterCount').innerText = count + "/750";
  }
}
